import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import TournamentRating from "./TournamentRating";
import RatingTable from "../../ratings/RatingTable";

// Top-level "Rating" tab (Tournament.js) used to render RatingTable.js
// (the full/overall rating standings) alone - очки турніру (this
// tournament's own results) was only reachable as a sub-tab buried inside
// "Участники". This merges both into the one Rating tab behind the same
// stage-tabs-scroll sub-tab bar TournamentPlayers.js already uses for its
// own List/Результати switch, so both "views" of rating live in one place.
const TournamentRatingTab = ({ tournament, is_authorized, refreshKey, searchChips }) => {
    const { t } = useTranslation();
    const [subTab, setSubTab] = useState("points");

    return (
        <>
            <ul className="tabs" style={{ marginTop: "10px", marginBottom: "10px" }}>
                <li className="stage-tabs-wrap">
                    <ul className="stage-tabs-scroll">
                        <li className={subTab === "points" ? "active" : ""}>
                            <a href="#" onClick={(e) => { e.preventDefault(); setSubTab("points"); }}>{t("Tournament points")}</a>
                        </li>
                        <li className={subTab === "overall" ? "active" : ""}>
                            <a href="#" onClick={(e) => { e.preventDefault(); setSubTab("overall"); }}>{t("Overall rating")}</a>
                        </li>
                    </ul>
                </li>
            </ul>

            {subTab === "points" ? (
                // Forced to "list" (no grid toggle here) - this view's only
                // job on this tab is to read like RatingTable's own rows
                // below it, not to duplicate Участники's full grid/list
                // picker.
                <TournamentRating
                    tournament={tournament}
                    is_authorized={is_authorized}
                    viewMode="list"
                    searchChips={searchChips}
                />
            ) : (
                <RatingTable key={refreshKey} ratingId={tournament?.rating} />
            )}
        </>
    );
};

export default TournamentRatingTab;
